<template>
    <div
        class="transition-all delay-1000 duration-500 bg-slate-50 ring-slate-50 ring-[10px] hover:bg-slate-200 hover:ring-slate-200 rounded-[1px]">
        <div class="flex gap-[10px] flex-col" :class="{ 'bg-red-500': !mention.cover }">

            <div v-if="mention.cover" class="w-full border border-slate-200 rounded-[4px] overflow-hidden">
                <div
                    :style="{ backgroundColor: mention.cover.hex, position: 'relative', paddingBottom: `${(mention.cover.height / mention.cover.width) * 100}%` }">
                    <img :src="mention.cover.image" class="absolute top-0 left-0 w-full h-full object-cover"
                        loading="lazy" />
                </div>
            </div>

            <div class="flex justify-between items-center">
                <div class="flex flex-row gap-x-[5px] items-center">
                    <div :class="['size-[20px] rounded-[2px] overflow-hidden']">
                        <img v-if="mention.platform.favicon" :src="mention.platform.favicon"
                            class="w-full h-full object-cover" />
                        <div v-else class="w-full h-full bg-slate-700"></div>
                    </div>
                    <a :href="mention.url" target="_blank" class="flex flex-row gap-[10px] items-center">
                        <StarIcon v-if="mention.is_official" class="size-[20px] text-yellow-500" />
                        <InformationCircleIcon v-if="mention.is_guide" class="size-[20px] text-teal-500" />
                        {{ mention.platform.name }}
                    </a>
                </div>
                <div class="flex flex-row gap-[10px]">
                    <input type="date" :value="startDate"
                        class="block w-full rounded-md bg-white px-[10px] h-[30px] text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                    <div v-if="startDate != props.mention.date">Save</div>
                </div>
            </div>

            <div v-html="mention.title" v-if="!mention.is_guide" class="font-bold opacity-80">
            </div>

            <div v-html="mention.text" v-if="!mention.is_guide"></div>

            <div class="flex flex-row gap-[10px]">
                <EditButton :href="route(`${prefixRoute}.mention.show`, mention.id)" />
                <EditButton :href="route(`${prefixRoute}.mention.remove`, mention.id)" :icon="TrashIcon" />
                <EditButton :href="route(`${prefixRoute}.mention.verify`, mention.id)" :icon="CheckIcon"
                    :hoverIconColor="'text-green-500'" />
                <EditButton :href="route(`${prefixRoute}.mention.attention`, mention.id)" :icon="HeartIcon"
                    :defaultIconColor="mention.attention ? 'text-red-500' : undefined"
                    :hoverIconColor="mention.attention ? 'text-red-900' : undefined" />
            </div>

        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import EditButton from '@/Components/Tables/EditButton.vue';
import { TrashIcon, CheckIcon, HeartIcon, StarIcon, InformationCircleIcon } from '@heroicons/vue/outline';

const props = defineProps({
    mention: Object,
    prefixRoute: String
});

const startDate = ref(null)

onMounted(() => {
    startDate.value = props.mention.date
})


</script>
